export default __webpack_public_path__ + "static/media/file_00001.1e3b8875.pdf";